// extracted by mini-css-extract-plugin
export default {"root":"conclusion-module--root--MPW5B","text1":"conclusion-module--text1--Rx99M","text2":"conclusion-module--text2--mAVuX","action":"conclusion-module--action--L1zry"};